// extracted by mini-css-extract-plugin
export default {"xca-spin-container":"SpinContainerXca__xca-spin-container--KLs7F"};